export function buildQueryParams(
  params: Record<string, string | number | boolean | undefined | null>,
): URLSearchParams {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      searchParams.set(key, String(value));
    }
  });

  return searchParams;
}

export function buildUrl(
  baseUrl: string,
  params?: Record<string, string | number | boolean | undefined | null>,
): string {
  if (!params) return baseUrl;

  const queryString = buildQueryParams(params).toString();
  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
}
